module.exports = __webpack_public_path__ + "static/media/723-quiet-journey.4f364df9.png";